<div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
  <div class="d-flex align-items-center gap-3">
    <div>
      <h5 class="mb-1 fw-bold">Labours Daily Attendance</h5>
      <span class="sub-text">Track daily labour check-ins and check-outs</span>
    </div>
  </div>

  <div class="d-flex gap-2">
    <button class="btn btn-soft-primary btn-sm d-flex align-items-center gap-2" (click)="openExportModal()">
      <i class="bi bi-download"></i>
      Export Report
    </button>
    <button class="btn btn-outline-danger" (click)="openCheckOutModal(checkOutModal)">
      <i class="bi bi-box-arrow-right"></i>
      Check-Out Labours
    </button>
    <button class="btn btn-primary btn-enjochem" (click)="openCheckInModal(checkInModal)">
      <i class="bi bi-person-plus"></i>
      Check-In Labours
    </button>
  </div>
</div>

<!-- Search Filter -->
<div class="row mb-3">
  <div class="col-12 px-0">
    <div class="input-group">
      <span class="input-group-text bg-white border-end-0">
        <i class="bi bi-search text-muted"></i>
      </span>
      <input
        type="text"
        class="form-control border-start-0 ps-0"
        placeholder="Search by name..."
        [(ngModel)]="searchTerm"
        (keyup)="onSearchKeyUp()" />
    </div>
  </div>
</div>

@if (isAttendanceDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  @if (checkedInLabours.length === 0) {
    <div class="text-center py-4 text-muted">
      <app-info-alert>No labour is checked-in yet.</app-info-alert>
    </div>
  } @else {
    <div class="table-responsive">
      <table class="table align-middle">
        <thead class="text-muted">
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Department</th>
            <th>Warehouse</th>
            <th>Check-In Time</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let labour of checkedInLabours">
            <td>{{ labour.labour.full_name }}</td>
            <td>{{ labour.labour.type_of_labour }}</td>
            <td>{{ labour.labour.department }}</td>
            <td>{{ labour.labour.warehouse.name }}</td>
            <td>{{ labour.start_time | date: 'shortTime' }}</td>
            <td class="text-center">
              @if (labour.end_time) {
                <span class="text-danger">Checked-out</span>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }
}

@if (checkedInLabours.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [totalCount]="totalCount"
    [pageSize]="10"
    [hasNextPage]="hasNextPage"
    [hasPreviousPage]="hasPreviousPage"
    (pageChange)="onPageChange($event)"></app-pagination>
}

<!-- Export Modal -->
<ng-template #exportModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title fw-bold">Export Attendance Sheet</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if (exportError) {
      <app-error-alert [error]="exportError" class="mb-3"></app-error-alert>
    }
    <div class="row g-3">
      <div class="col-6">
        <label class="form-label">
          From Date
          <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" [(ngModel)]="exportFromDate" />
      </div>
      <div class="col-6">
        <label class="form-label">
          To Date
          <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" [(ngModel)]="exportToDate" />
      </div>
      <div class="col-12">
        <label class="form-label">Labour</label>
        <ng-select
          [items]="labours"
          bindLabel="full_name"
          bindValue="id"
          placeholder="All Labours"
          [(ngModel)]="exportLabourId"
          [clearable]="true"
          [searchable]="true"></ng-select>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="modal.dismiss()" [disabled]="isExporting">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-soft-primary btn-sm d-flex align-items-center gap-2"
      (click)="onExportSubmit(modal)"
      [disabled]="isExporting || !exportFromDate || !exportToDate">
      @if (isExporting) {
        <span class="spinner-border spinner-border-sm"></span>
        Exporting...
      } @else {
        <i class="bi bi-download"></i>
        Export
      }
    </button>
  </div>
</ng-template>

<ng-template #checkInModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Check-In Labours</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <label class="form-label">Select Labours</label>

    <!-- Select All Option -->
    <div class="form-check mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="selectAll"
        (change)="toggleSelectAll($event)"
        [checked]="areAllSelectableSelected()" />
      <label class="form-check-label" for="selectAll">Select All</label>
    </div>

    <div class="form-check" *ngFor="let labour of labours">
      <input
        class="form-check-input"
        type="checkbox"
        [id]="labour.id"
        [value]="labour.id"
        (change)="onLabourToggle(labour.id, $event)"
        [checked]="selectedLabourIds.includes(labour.id)"
        [disabled]="isAlreadyCheckedIn(labour)" />
      <label class="form-check-label" [for]="labour.id">
        {{ labour.full_name }}
      </label>
    </div>

    <hr />

    <label for="startTime" class="form-label mt-2">Start Time</label>
    <input id="startTime" type="datetime-local" class="form-control" [(ngModel)]="startTime" />
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!startTime || selectedLabourIds.length === 0"
      (click)="saveCheckIn(); modal.close()">
      Save
    </button>
  </div>
</ng-template>

<ng-template #checkOutModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Check-Out Labours</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <form [formGroup]="checkOutForm" (ngSubmit)="submitCheckOut()">
    <div class="modal-body">
      <label class="form-label">Select Labours</label>

      @if (checkableLabours.length === 0) {
        <p class="text-muted small">No labours available for check-out.</p>
      } @else {
        <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="selectAllCheckOut"
            (change)="toggleSelectAllCheckOut($event)"
            [checked]="areAllCheckOutSelected()" />
          <label class="form-check-label" for="selectAllCheckOut">Select All</label>
        </div>

        <div class="form-check" *ngFor="let labour of checkableLabours">
          <input
            class="form-check-input"
            type="checkbox"
            [id]="'co-' + labour.labour.id"
            [value]="labour.labour.id"
            (change)="onCheckOutLabourToggle(labour.labour.id, $event)"
            [checked]="selectedCheckOutLabourIds.includes(labour.labour.id)" />
          <label class="form-check-label" [for]="'co-' + labour.labour.id">
            {{ labour.labour.full_name }}
          </label>
        </div>
      }

      <hr />

      <label class="form-label mt-2">End Time</label>
      <input type="datetime-local" class="form-control" formControlName="end_time" />

      @if (checkOutErrors.length > 0) {
        <div class="mt-3">
          <p class="text-danger small fw-bold mb-1">Some labours could not be checked out:</p>
          <ul class="list-unstyled mb-0">
            <li *ngFor="let err of checkOutErrors" class="text-danger small">
              <i class="bi bi-exclamation-triangle-fill me-1"></i>
              {{ err.detail }}
            </li>
          </ul>
        </div>
      }
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button
        type="submit"
        [disabled]="checkOutForm.invalid || selectedCheckOutLabourIds.length === 0"
        class="btn btn-primary btn-enjochem">
        Check-Out
      </button>
    </div>
  </form>
</ng-template>
